import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from "react";

function Quote() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="quote" className=" pt-32">
      <div className="container">
        <div className="flex flex-wrap">
          <div className="mt-5 w-full px-4 pt-5 md:w-1/2" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="400" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
            <h1 className=" mb-4 font-mukta text-2xl font-bold text-primary md:text-4xl">
              Quote
            </h1>
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              Random Quote
            </h2>
            <p className="text-sm font-medium text-slate-500 md:text-base">
              "Programming is the art of transforming abstract concepts into
              tangible solutions through the use of logic, creativity, and
              technology. It involves creating applications, solving problems,
              and collaborating as a team. Programming is an ongoing learning
              journey that allows us to face challenges, realize ideas, and
              shape the digital world." - Anonymous
            </p>
          </div>
          <div className="w-full md:w-1/2" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="400" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
            <div className="w-full">
              <img
                height={400}
                width={500}
                src="./img/coding.jpg"
                alt="hadi"
                className="mx-auto max-w-full "
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Quote;
